import React from 'react';

import './styles.less';

export const DISCARD_TRIM_BUTTON_CLASS = 'trim-bar-discard-trim-button';

const DiscardTrimButton = props => {
  const { selectedTrimRange } = props;

  const canDiscardTrim = selectedTrimRange != null;

  const discardTrimClass = canDiscardTrim ? 'enabled' : '';
  const discardTrimOnClick = canDiscardTrim ? props.onDiscardTrimRange : null;

  return (
    <div
      className={`trim-bar-button ${DISCARD_TRIM_BUTTON_CLASS} ${discardTrimClass}`}
      onClick={discardTrimOnClick}
    >
      <span className="icon" />
      <span className="label">Remove Trim</span>
    </div>
  );
};

export default DiscardTrimButton;
